import React, { useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useTranslation, Trans } from 'react-i18next';
import LanguageSwitcher from '../../Component/LanguageSwitcher';

const NationalPS = () => {
    const { t } = useTranslation('NationalPS');

    useEffect(() => {
        document.title = t('title');
        const metaDesc = document.querySelector('meta[name="description"]');
        if (metaDesc) {
            metaDesc.setAttribute('content', t('metaDescription'));
        }
    }, [t]);

    return (
        <div>
            <header className="d-flex justify-content-end align-items-center p-3 border-bottom">
                <LanguageSwitcher />
            </header>

            <div className="webview">
                <Container>
                    <Row>
                        <Col xs={12}>
                            <Trans
                                i18nKey="introPara1"
                                ns="NationalPS"
                                components={[
                                    <strong key="0" />,
                                    <strong key="1" />,
                                    <a
                                        key="2"
                                        href="https://www.goodreturns.in/classroom/2016/10/national-pension-system-nps-2016-7-important-things-know-509801.html"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    />
                                ]}
                            />
                            <br /><br />
                            <Trans
                                i18nKey="introPara2"
                                ns="NationalPS"
                                components={[
                                    <a
                                        key="0"
                                        href="https://www.goodreturns.in/personal-finance/investment/14-easy-steps-to-open-nps-tier-ii-account-online-for-free-1162824.html"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    />
                                ]}
                            />

                            <h2><Trans i18nKey="aboutHeader" ns="NationalPS" /></h2>
                            
                            <Trans
                                i18nKey="aboutPara1"
                                ns="NationalPS"
                                components={[<strong key="0" />]}
                            />
                            <br /><br />
                            <Trans
                                i18nKey="aboutPara2"
                                ns="NationalPS"
                                components={[
                                    <a
                                        key="0"
                                        href="https://www.goodreturns.in/section-80c-of-income-tax-act-s1.html"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    />
                                ]}
                            />
                            <br /><br />
                            <Trans i18nKey="aboutPara3" ns="NationalPS" />
                            <br /><br />
                            <Trans i18nKey="aboutPara4" ns="NationalPS" />
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    );
};

export default NationalPS;
